import {Component, Input} from '@angular/core';
import {DownloadInfoWithLineItem} from '../../../shopping-cart/download.service';
import {AddOffer, AddProduct, UserDownloadInfo} from '@uofu-uss-aux/software-catalog-ng-core';
import {PurchaseTitleComponent} from '../../purchase-title/purchase-title.component';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {DownloadComponent} from '../../../download/download/download.component';
import {CatalogGraphicComponent} from '../../../graphic/catalog-graphic/catalog-graphic.component';

@Component({
  selector: 'app-download-item',
  templateUrl: './download-item.component.html',
  styleUrls: ['./download-item.component.scss'],
  standalone: true,
  imports: [
    PurchaseTitleComponent,
    NgIf,
    NgForOf,
    DownloadComponent,
    NgClass,
    CatalogGraphicComponent
  ]
})
export class DownloadItemComponent extends AddProduct(AddOffer(Object)) {

  private _downloadInfo: DownloadInfoWithLineItem;

  @Input() set downloadInfo(di: DownloadInfoWithLineItem) {
    this._downloadInfo = di;
    this.product = di?.lineItem.product;
    this.offer = di?.lineItem.offering;
  }

  get downloadInfo() {
    return this._downloadInfo;
  }

  get downloadsAvailable(): boolean {
    return !!this.downloads.length;
  }

  get downloads(): ReadonlyArray<UserDownloadInfo> {
    return this.downloadInfo?.downloadInfo.downloads || [];
  }

  get licensesAvailable(): boolean {
    return !!this.licenses.length;
  }

  get licenses(): ReadonlyArray<UserDownloadInfo> {
    return this.downloadInfo?.downloadInfo.licenses || [];
  }

}
